import React, { createContext } from 'react'

import Coin from 'components/CommonUI/svgIcons/Coin'
import LightningCharge from 'components/CommonUI/svgIcons/LightningCharge'
import Vector from 'components/CommonUI/svgIcons/Vector'

import TotalInfoCard from 'components/TotalInfoCard/TotalInfoCard'
import { withIntlNumber } from 'utils/withIntl'

export const FetchingContext = createContext(false)

const TopTotalInfo = ({
  energy_intensity = null,
  total_consumption = null,
  total_cost = null,
  className = '',
  isFetching,
}) => {
  return (
    <FetchingContext.Provider value={isFetching}>
      <div className={`top_toptal_info_container ${className}`}>
        <TotalInfoCard
          iconComponent={LightningCharge}
          value={withIntlNumber(total_consumption)}
          unit={'kWh'}
          color="#1772F5"
          className="facility_inform_card"
          title={'Total consumption'}
        />
        <TotalInfoCard
          iconComponent={Coin}
          value={withIntlNumber(total_cost)}
          unit={'AED'}
          color="#4AA652"
          className="facility_inform_card"
          title={'Total cost'}
          //percent="5.54%"
        />
        <TotalInfoCard
          iconComponent={Vector}
          value={withIntlNumber(energy_intensity)}
          unit={
            <span>
              kWh/m<sup>2</sup>
            </span>
          }
          color="#D64A92"
          className="facility_inform_card"
          title={'AVG energy intensity'}
        />
      </div>
    </FetchingContext.Provider>
  )
}

export default TopTotalInfo
